module.exports = __webpack_public_path__ + "img/team-member-05.58c09c91.jpg";